import { render, staticRenderFns } from "./ProducedBy.vue?vue&type=template&id=7fc5f734&scoped=true&"
import script from "./ProducedBy.vue?vue&type=script&lang=js&"
export * from "./ProducedBy.vue?vue&type=script&lang=js&"
import style0 from "./ProducedBy.vue?vue&type=style&index=0&id=7fc5f734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc5f734",
  null
  
)

export default component.exports